// (function(){
//   'use strict';
//   var root = document.querySelector('[data-dlp-reviews]');
// if (!root) {
//     console.log('DLP Reviews section not found.');
//     return;
// }
//   var STORE_ID = root.dataset.okendoStoreId;
//   var PRODUCT_ID = root.dataset.okendoProductId;

//   var PER_PAGE = 3;
//   var allReviews = [];
//   var currentPage = 1;
//   var activeStarFilter = null;

//   function $(sel){ return root.querySelector(sel); }
//   function $all(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

//   function getInitials(name){
//     if (!name) return '?';
//     var parts = name.trim().split(/\s+/);
//     if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
//     return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
//   }

//   function getFiltered(){
//     var q = ($('[data-dlp-rev-search]') && $('[data-dlp-rev-search]').value || '').toLowerCase().trim();
//     return allReviews.filter(function(r){
//       var matchStar = activeStarFilter === null || r.rating === activeStarFilter;
//       var matchSearch = !q || r.body.toLowerCase().indexOf(q) !== -1 || r.name.toLowerCase().indexOf(q) !== -1 || r.title.toLowerCase().indexOf(q) !== -1;
//       return matchStar && matchSearch;
//     });
//   }

//   function starsHTML(rating){
//     var r = Math.min(5, Math.max(0, Math.round(rating)));
//     var out = '';
//     for (var i = 0; i < 5; i++){
//       out += i < r
//         ? '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>'
//         : '<svg width="20" height="20" viewBox="0 0 20 20" style="opacity:.25"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>';
//     }
//     return out;
//   }

//   function cardHTML(r){
//     var LIMIT = 180;
//     var isLong = r.body.length > LIMIT;
//     var shortText = isLong ? r.body.slice(0, LIMIT).trimEnd() + '…' : r.body;
//     var bodyId = 'dlp-rev-body-' + Math.random().toString(36).slice(2, 8);
//     var mediaHTML = '';
//     if (r.media && r.media.length){
//       var first = r.media[0];
//       if (first.type === 'video' && (first.fullWebmUrl || first.videoUrl || first.fullSizeUrl)){
//         var videoSrc = first.fullWebmUrl || first.videoUrl || first.fullSizeUrl;
//         mediaHTML = '<div class="dlp-rev-media"><video controls playsinline preload="metadata" poster="' + (first.videoPosterUrl || first.thumbnailUrl || '') + '"><source src="' + videoSrc + '"></video></div>';
//       } else {
//         var imgSrc = first.fullSizeUrl || first.thumbnailUrl || first.imageUrl || first.url;
//         if (imgSrc) mediaHTML = '<div class="dlp-rev-media"><img src="' + imgSrc + '" alt="" loading="lazy"></div>';
//       }
//     }
//     var avatarHTML = r.avatar
//       ? '<img src="' + r.avatar + '" alt="' + r.name + '" class="dlp-rev-avatar" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'"><div class="dlp-rev-avatar dlp-rev-avatar-initials" style="display:none">' + getInitials(r.name) + '</div>'
//       : '<div class="dlp-rev-avatar dlp-rev-avatar-initials">' + getInitials(r.name) + '</div>';
//     return '' +
//       '<div class="dlp-rev-card">' + mediaHTML +
//       '<div class="dlp-rev-card-top"><span class="dlp-rev-card-stars">' + starsHTML(r.rating) + '</span><span class="dlp-rev-verified">Verified</span></div>' +
//       (r.title ? '<div class="dlp-rev-card-title">' + r.title + '</div>' : '<div class="dlp-rev-card-title" style="min-height:44px"></div>') +
//       '<div class="dlp-rev-card-body" id="' + bodyId + '" data-full="' + r.body.replace(/"/g, '&quot;') + '" data-short="' + shortText.replace(/"/g, '&quot;') + '" data-expanded="false">' +
//       '<span class="dlp-rev-body-text">' + shortText + '</span>' + (isLong ? '<button type="button" class="dlp-rev-read-more" data-target="' + bodyId + '">Read More</button>' : '') + '</div>' +
//       '<div class="dlp-rev-card-auth">' + avatarHTML + '<div><span class="dlp-rev-card-name">' + r.name + '</span>' + (r.date ? '<span class="dlp-rev-card-date">' + r.date + '</span>' : '') + '</div></div>' +
//       '</div>';
//   }

//   function getPageNumbers(current, total){
//     var pages = [];
//     if (total <= 7){ for (var i = 1; i <= total; i++) pages.push(i); return pages; }
//     pages.push(1);
//     if (current > 3) pages.push('...');
//     var start = Math.max(2, current - 1), end = Math.min(total - 1, current + 1);
//     for (var j = start; j <= end; j++) pages.push(j);
//     if (current < total - 2) pages.push('...');
//     pages.push(total);
//     return pages;
//   }

//   function render(){
//     var grid = $('[data-dlp-rev-dynamic-grid]');
//     var pages = $('[data-dlp-rev-pages]');
//     if (!grid || !pages) return;
//     var filtered = getFiltered();

//     if (!filtered.length){
//       var msg = allReviews.length === 0 ? 'No reviews yet. Be the first to leave a review!' : 'No reviews match your search.';
//       grid.innerHTML = '<p class="dlp-rev-loading">' + msg + '</p>';
//       pages.innerHTML = '';
//       return;
//     }

//     var isMobile = window.innerWidth < 768;
//     if (isMobile){
//       var showCount = currentPage * PER_PAGE;
//       var slice = filtered.slice(0, showCount);
//       var hasMore = showCount < filtered.length;
//       grid.innerHTML = slice.map(cardHTML).join('');
//       pages.innerHTML = hasMore ? '<button type="button" class="dlp-rev-load-more" data-dlp-rev-load-more>Load more</button>' : '';
//     } else {
//       var totalPages = Math.ceil(filtered.length / PER_PAGE);
//       if (currentPage > totalPages) currentPage = 1;
//       var slice2 = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);
//       grid.innerHTML = slice2.map(cardHTML).join('');

//       var html = '';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="1" ' + (currentPage === 1 ? 'disabled' : '') + '><span>«</span></button>';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage - 1) + '" ' + (currentPage === 1 ? 'disabled' : '') + '><span>‹</span></button>';
//       getPageNumbers(currentPage, totalPages).forEach(function(p){
//         if (p === '...') html += '<span class="dlp-pg-ellipsis">…</span>';
//         else html += '<button type="button" class="dlp-pg' + (p === currentPage ? ' is-active' : '') + '" data-page="' + p + '">' + p + '</button>';
//       });
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage + 1) + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>›</span></button>';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + totalPages + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>»</span></button>';
//       pages.innerHTML = html;
//     }
//   }

//   root.addEventListener('click', function(e){
//     var pageBtn = e.target.closest('[data-page]');
//     if (pageBtn){ currentPage = parseInt(pageBtn.dataset.page, 10) || 1; render(); return; }
//     var loadMore = e.target.closest('[data-dlp-rev-load-more]');
//     if (loadMore){ currentPage++; render(); return; }
//     var readMore = e.target.closest('.dlp-rev-read-more');
//     if (readMore){
//       var bodyEl = document.getElementById(readMore.dataset.target);
//       if (!bodyEl) return;
//       var textEl = bodyEl.querySelector('.dlp-rev-body-text');
//       var isExpanded = bodyEl.dataset.expanded === 'true';
//       if (isExpanded){ textEl.textContent = bodyEl.dataset.short; readMore.textContent = 'Read More'; bodyEl.dataset.expanded = 'false'; }
//       else { textEl.textContent = bodyEl.dataset.full; readMore.textContent = 'Read Less'; bodyEl.dataset.expanded = 'true'; }
//     }
//   });

//   function buildStarBarsFromAggregate(agg){
//     var barsEl = $('[data-dlp-rev-bars]');
//     if (!barsEl) return;
//     var dist = agg.reviewCountByLevel || {};
//     var total = agg.reviewCount || 1;
//     var html = '';
//     [5, 4, 3, 2, 1].forEach(function(star){
//       var count = dist['level' + star + 'Count'] || 0;
//       var pct = Math.round((count / total) * 100);
//       var isActive = activeStarFilter === star;
//       var filled = '<span class="dlp-rev-bar-stars__filled">' + Array(star + 1).join('★') + '</span>';
//       var empty = star < 5 ? '<span class="dlp-rev-bar-stars__empty">' + Array(5 - star + 1).join('★') + '</span>' : '';
//       html += '<div class="dlp-rev-bar-row' + (isActive ? ' is-active' : '') + '" data-star="' + star + '">' +
//         '<span class="dlp-rev-bar-stars">' + filled + empty + '</span>' +
//         '<div class="dlp-rev-bar-track"><div class="dlp-rev-bar-fill" style="width:' + pct + '%"></div></div>' +
//         '<span class="dlp-rev-bar-count">' + count + '</span></div>';
//     });
//     barsEl.innerHTML = html;
//     $all('.dlp-rev-bar-row').forEach(function(row){
//       row.addEventListener('click', function(){
//         var star = parseInt(row.dataset.star, 10);
//         activeStarFilter = activeStarFilter === star ? null : star;
//         currentPage = 1; render(); buildStarBarsFromAggregate(agg);
//       });
//     });
//   }

//   function initSearch(){
//     var input = $('[data-dlp-rev-search]'); if (!input) return;
//     input.addEventListener('input', function(){ currentPage = 1; render(); });
//   }
//   function initSort(){
//     var select = $('[data-dlp-rev-sort]'); if (!select) return;
//     select.addEventListener('change', function(){
//       currentPage = 1;
//       if (this.value === 'highest_rating') allReviews.sort(function(a, b){ return b.rating - a.rating; });
//       else if (this.value === 'lowest_rating') allReviews.sort(function(a, b){ return a.rating - b.rating; });
//       render();
//     });
//   }
//   function wireWriteBtn(){
//     var btn = $('[data-dlp-rev-write]'); if (!btn) return;
//     btn.addEventListener('click', function(){
//       var okendoBtn = document.querySelector('.oke-w-writeReview');
//       if (okendoBtn) okendoBtn.click();
//       else document.querySelector('[data-oke-widget]') && document.querySelector('[data-oke-widget]').scrollIntoView({ behavior: 'smooth' });
//     });
//   }

//   function updateSitewideCount(total, avg){
//     var totalFormatted = Number(total).toLocaleString();
//     document.querySelectorAll('[data-dlp-review-count]').forEach(function(el){ el.textContent = totalFormatted; });
//     document.querySelectorAll('[data-dlp-rating-score]').forEach(function(el){ el.textContent = avg + '/5'; });
//   }

//   async function loadOkendoReviews(){
//     if (!STORE_ID || !PRODUCT_ID) { render(); return; }
//     try {
//       var aggRes = await fetch('https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + PRODUCT_ID + '/review_aggregate');
//       var aggData = await aggRes.json();
//       var agg = aggData.reviewAggregate || {};
//       var total = agg.reviewCount || 0;
//       var avg = total ? (agg.reviewRatingValuesTotal / total).toFixed(1) : '0.0';

//       var countEl = $('[data-dlp-rev-count]'); if (countEl) countEl.textContent = 'Based on ' + Number(total).toLocaleString() + ' reviews';
//       var avgEl = $('[data-dlp-rev-avg]'); if (avgEl) avgEl.textContent = avg;
//       updateSitewideCount(total, avg);
//       buildStarBarsFromAggregate(agg);

//       var seenIds = {};
//       var allFetched = [];
//       var nextUrl = 'https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + PRODUCT_ID + '/reviews?limit=100';
//       while (nextUrl){
//         var res = await fetch(nextUrl);
//         if (!res.ok) break;
//         var data = await res.json();
//         var batch = data.reviews || [];
//         if (!batch.length) break;
//         batch.forEach(function(r){
//           var uid = r.reviewId || r.id || ((r.dateCreated || '') + '|' + r.rating + '|' + (r.reviewer && r.reviewer.displayName) + '|' + (r.body || '').slice(0, 30));
//           if (!seenIds[uid]){ seenIds[uid] = true; allFetched.push(r); }
//         });
//         nextUrl = data.nextUrl ? ('https://api.okendo.io/v1' + (data.nextUrl.indexOf('/v1') === 0 ? data.nextUrl.slice(3) : data.nextUrl)) : null;
//         if (allFetched.length >= total && total > 0) break;
//       }

//       allReviews = allFetched.map(function(r){
//         return {
//           rating: r.rating || 5,
//           title: r.title || '',
//           body: r.body || '',
//           name: (r.reviewer && r.reviewer.displayName) || 'Anonymous',
//           avatar: (r.reviewer && r.reviewer.avatarUrl) || null,
//           media: r.media || r.reviewMedia || r.mediaItems || [],
//           date: r.dateCreated ? new Date(r.dateCreated).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''
//         };
//       });
//       allReviews.sort(function(a, b){ return (b.media && b.media.length ? 1 : 0) - (a.media && a.media.length ? 1 : 0); });

//       render(); initSort(); initSearch(); wireWriteBtn();
//       window.addEventListener('resize', render);
//     } catch (err){
//       console.error('[DLP] Okendo reviews error:', err);
//       render();
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', loadOkendoReviews);
// } else {
//     loadOkendoReviews();
// }
// })();





(function(){
  'use strict';
  var root = document.querySelector('[data-dlp-reviews]');
  if (!root) {
    console.log('DLP Reviews section not found.');
    return;
  }
  var STORE_ID = root.dataset.okendoStoreId;
  var PRODUCT_IDS = [root.dataset.okendoProductIdStandard, root.dataset.okendoProductIdLarge].filter(Boolean);

  var PER_PAGE = 3;
  var allReviews = [];
  var currentPage = 1;
  var activeStarFilter = null;
  var resizeBound = false;

  function $(sel){ return root.querySelector(sel); }
  function $all(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function getInitials(name){
    if (!name) return '?';
    var parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  function getFiltered(){
    var q = ($('[data-dlp-rev-search]') && $('[data-dlp-rev-search]').value || '').toLowerCase().trim();
    return allReviews.filter(function(r){
      var matchStar = activeStarFilter === null || r.rating === activeStarFilter;
      var matchSearch = !q || r.body.toLowerCase().indexOf(q) !== -1 || r.name.toLowerCase().indexOf(q) !== -1 || r.title.toLowerCase().indexOf(q) !== -1;
      return matchStar && matchSearch;
    });
  }

  function starsHTML(rating){
    var r = Math.min(5, Math.max(0, Math.round(rating)));
    var out = '';
    for (var i = 0; i < 5; i++){
      out += i < r
        ? '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>'
        : '<svg width="20" height="20" viewBox="0 0 20 20" style="opacity:.25"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>';
    }
    return out;
  }

  function cardHTML(r){
    var LIMIT = 180;
    var isLong = r.body.length > LIMIT;
    var shortText = isLong ? r.body.slice(0, LIMIT).trimEnd() + '…' : r.body;
    var bodyId = 'dlp-rev-body-' + Math.random().toString(36).slice(2, 8);
    var mediaHTML = '';
    if (r.media && r.media.length){
      var first = r.media[0];
      if (first.type === 'video' && (first.fullWebmUrl || first.videoUrl || first.fullSizeUrl)){
        var videoSrc = first.fullWebmUrl || first.videoUrl || first.fullSizeUrl;
        mediaHTML = '<div class="dlp-rev-media"><video controls playsinline preload="metadata" poster="' + (first.videoPosterUrl || first.thumbnailUrl || '') + '"><source src="' + videoSrc + '"></video></div>';
      } else {
        var imgSrc = first.fullSizeUrl || first.thumbnailUrl || first.imageUrl || first.url;
        if (imgSrc) mediaHTML = '<div class="dlp-rev-media"><img src="' + imgSrc + '" alt="" loading="lazy"></div>';
      }
    }
    var avatarHTML = r.avatar
      ? '<img src="' + r.avatar + '" alt="' + r.name + '" class="dlp-rev-avatar" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'"><div class="dlp-rev-avatar dlp-rev-avatar-initials" style="display:none">' + getInitials(r.name) + '</div>'
      : '<div class="dlp-rev-avatar dlp-rev-avatar-initials">' + getInitials(r.name) + '</div>';
    return '' +
      '<div class="dlp-rev-card">' + mediaHTML +
      '<div class="dlp-rev-card-top"><span class="dlp-rev-card-stars">' + starsHTML(r.rating) + '</span><span class="dlp-rev-verified">Verified</span></div>' +
      (r.title ? '<div class="dlp-rev-card-title">' + r.title + '</div>' : '<div class="dlp-rev-card-title" style="min-height:44px"></div>') +
      '<div class="dlp-rev-card-body" id="' + bodyId + '" data-full="' + r.body.replace(/"/g, '&quot;') + '" data-short="' + shortText.replace(/"/g, '&quot;') + '" data-expanded="false">' +
      '<span class="dlp-rev-body-text">' + shortText + '</span>' + (isLong ? '<button type="button" class="dlp-rev-read-more" data-target="' + bodyId + '">Read More</button>' : '') + '</div>' +
      '<div class="dlp-rev-card-auth">' + avatarHTML + '<div><span class="dlp-rev-card-name">' + r.name + '</span>' + (r.date ? '<span class="dlp-rev-card-date">' + r.date + '</span>' : '') + '</div></div>' +
      '</div>';
  }

  function getPageNumbers(current, total){
    var pages = [];
    if (total <= 7){ for (var i = 1; i <= total; i++) pages.push(i); return pages; }
    pages.push(1);
    if (current > 3) pages.push('...');
    var start = Math.max(2, current - 1), end = Math.min(total - 1, current + 1);
    for (var j = start; j <= end; j++) pages.push(j);
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  function render(){
    var grid = $('[data-dlp-rev-dynamic-grid]');
    var pages = $('[data-dlp-rev-pages]');
    if (!grid || !pages) return;
    var filtered = getFiltered();

    if (!filtered.length){
      var msg = allReviews.length === 0 ? 'No reviews yet. Be the first to leave a review!' : 'No reviews match your search.';
      grid.innerHTML = '<p class="dlp-rev-loading">' + msg + '</p>';
      pages.innerHTML = '';
      return;
    }

    var isMobile = window.innerWidth < 768;
    if (isMobile){
      var showCount = currentPage * PER_PAGE;
      var slice = filtered.slice(0, showCount);
      var hasMore = showCount < filtered.length;
      grid.innerHTML = slice.map(cardHTML).join('');
      pages.innerHTML = hasMore ? '<button type="button" class="dlp-rev-load-more" data-dlp-rev-load-more>Load more</button>' : '';
    } else {
      var totalPages = Math.ceil(filtered.length / PER_PAGE);
      if (currentPage > totalPages) currentPage = 1;
      var slice2 = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);
      grid.innerHTML = slice2.map(cardHTML).join('');

      var html = '';
      html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="1" ' + (currentPage === 1 ? 'disabled' : '') + '><span>«</span></button>';
      html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage - 1) + '" ' + (currentPage === 1 ? 'disabled' : '') + '><span>‹</span></button>';
      getPageNumbers(currentPage, totalPages).forEach(function(p){
        if (p === '...') html += '<span class="dlp-pg-ellipsis">…</span>';
        else html += '<button type="button" class="dlp-pg' + (p === currentPage ? ' is-active' : '') + '" data-page="' + p + '">' + p + '</button>';
      });
      html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage + 1) + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>›</span></button>';
      html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + totalPages + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>»</span></button>';
      pages.innerHTML = html;
    }
  }

  root.addEventListener('click', function(e){
    var pageBtn = e.target.closest('[data-page]');
    if (pageBtn){ currentPage = parseInt(pageBtn.dataset.page, 10) || 1; render(); return; }
    var loadMore = e.target.closest('[data-dlp-rev-load-more]');
    if (loadMore){ currentPage++; render(); return; }
    var readMore = e.target.closest('.dlp-rev-read-more');
    if (readMore){
      var bodyEl = document.getElementById(readMore.dataset.target);
      if (!bodyEl) return;
      var textEl = bodyEl.querySelector('.dlp-rev-body-text');
      var isExpanded = bodyEl.dataset.expanded === 'true';
      if (isExpanded){ textEl.textContent = bodyEl.dataset.short; readMore.textContent = 'Read More'; bodyEl.dataset.expanded = 'false'; }
      else { textEl.textContent = bodyEl.dataset.full; readMore.textContent = 'Read Less'; bodyEl.dataset.expanded = 'true'; }
    }
  });

  function buildStarBarsFromAggregate(agg){
    var barsEl = $('[data-dlp-rev-bars]');
    if (!barsEl) return;
    var dist = agg.reviewCountByLevel || {};
    var total = agg.reviewCount || 1;
    var html = '';
    [5, 4, 3, 2, 1].forEach(function(star){
      var count = dist['level' + star + 'Count'] || 0;
      var pct = Math.round((count / total) * 100);
      var isActive = activeStarFilter === star;
      var filled = '<span class="dlp-rev-bar-stars__filled">' + Array(star + 1).join('★') + '</span>';
      var empty = star < 5 ? '<span class="dlp-rev-bar-stars__empty">' + Array(5 - star + 1).join('★') + '</span>' : '';
      html += '<div class="dlp-rev-bar-row' + (isActive ? ' is-active' : '') + '" data-star="' + star + '">' +
        '<span class="dlp-rev-bar-stars">' + filled + empty + '</span>' +
        '<div class="dlp-rev-bar-track"><div class="dlp-rev-bar-fill" style="width:' + pct + '%"></div></div>' +
        '<span class="dlp-rev-bar-count">' + count + '</span></div>';
    });
    barsEl.innerHTML = html;
    $all('.dlp-rev-bar-row').forEach(function(row){
      row.addEventListener('click', function(){
        var star = parseInt(row.dataset.star, 10);
        activeStarFilter = activeStarFilter === star ? null : star;
        currentPage = 1; render(); buildStarBarsFromAggregate(agg);
      });
    });
  }

  function initSearch(){
    var input = $('[data-dlp-rev-search]'); if (!input) return;
    if (input._dlpBound) return;
    input._dlpBound = true;
    input.addEventListener('input', function(){ currentPage = 1; render(); });
  }
  function initSort(){
    var select = $('[data-dlp-rev-sort]'); if (!select) return;
    if (select._dlpBound) return;
    select._dlpBound = true;
    select.addEventListener('change', function(){
      currentPage = 1;
      if (this.value === 'highest_rating') allReviews.sort(function(a, b){ return b.rating - a.rating; });
      else if (this.value === 'lowest_rating') allReviews.sort(function(a, b){ return a.rating - b.rating; });
      render();
    });
  }
  function wireWriteBtn(){
    var btn = $('[data-dlp-rev-write]'); if (!btn) return;
    if (btn._dlpBound) return;
    btn._dlpBound = true;
    btn.addEventListener('click', function(){
      var okendoBtn = document.querySelector('.oke-w-writeReview');
      if (okendoBtn) okendoBtn.click();
      else document.querySelector('[data-oke-widget]') && document.querySelector('[data-oke-widget]').scrollIntoView({ behavior: 'smooth' });
    });
  }

  function updateSitewideCount(total, avg){
    var totalFormatted = Number(total).toLocaleString();
    document.querySelectorAll('[data-dlp-review-count]').forEach(function(el){ el.textContent = totalFormatted; });
    document.querySelectorAll('[data-dlp-rating-score]').forEach(function(el){ el.textContent = avg + '/5'; });
  }

  async function fetchAggregate(productId){
    var res = await fetch('https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + productId + '/review_aggregate');
    var data = await res.json();
    return data.reviewAggregate || {};
  }

  async function fetchAllReviewsForProduct(productId, expectedTotal){
    var seenIds = {};
    var fetched = [];
    var nextUrl = 'https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + productId + '/reviews?limit=100';
    while (nextUrl){
      var res = await fetch(nextUrl);
      if (!res.ok) break;
      var data = await res.json();
      var batch = data.reviews || [];
      if (!batch.length) break;
      batch.forEach(function(r){
        var uid = r.reviewId || r.id || ((r.dateCreated || '') + '|' + r.rating + '|' + (r.reviewer && r.reviewer.displayName) + '|' + (r.body || '').slice(0, 30));
        if (!seenIds[uid]){ seenIds[uid] = true; fetched.push(r); }
      });
      nextUrl = data.nextUrl ? ('https://api.okendo.io/v1' + (data.nextUrl.indexOf('/v1') === 0 ? data.nextUrl.slice(3) : data.nextUrl)) : null;
      if (fetched.length >= expectedTotal && expectedTotal > 0) break;
    }
    return fetched;
  }

  // ── loads and merges BOTH products into one combined review set ──
  async function loadOkendoReviews(){
    allReviews = [];
    currentPage = 1;
    activeStarFilter = null;

    var searchInput = $('[data-dlp-rev-search]');
    if (searchInput) searchInput.value = '';
    var sortSelect = $('[data-dlp-rev-sort]');
    if (sortSelect) sortSelect.value = 'created_at';

    var grid = $('[data-dlp-rev-dynamic-grid]');
    if (grid) grid.innerHTML = '<p class="dlp-rev-loading">Loading reviews…</p>';

    if (!STORE_ID || !PRODUCT_IDS.length) { render(); return; }

    try {
      // fetch aggregates for both products, then merge into one combined aggregate
      var aggs = await Promise.all(PRODUCT_IDS.map(fetchAggregate));

      var combinedTotal = 0;
      var combinedRatingSum = 0;
      var combinedDist = { level1Count: 0, level2Count: 0, level3Count: 0, level4Count: 0, level5Count: 0 };

      aggs.forEach(function(agg){
        combinedTotal += agg.reviewCount || 0;
        combinedRatingSum += agg.reviewRatingValuesTotal || 0;
        var dist = agg.reviewCountByLevel || {};
        [1, 2, 3, 4, 5].forEach(function(lvl){
          combinedDist['level' + lvl + 'Count'] += dist['level' + lvl + 'Count'] || 0;
        });
      });

      var combinedAvg = combinedTotal ? (combinedRatingSum / combinedTotal).toFixed(1) : '0.0';
      var combinedAgg = { reviewCount: combinedTotal, reviewCountByLevel: combinedDist };

      var countEl = $('[data-dlp-rev-count]'); if (countEl) countEl.textContent = 'Based on ' + Number(combinedTotal).toLocaleString() + ' reviews';
      var avgEl = $('[data-dlp-rev-avg]'); if (avgEl) avgEl.textContent = combinedAvg;
      buildStarBarsFromAggregate(combinedAgg);
      updateSitewideCount(combinedTotal, combinedAvg); // header row uses the same combined numbers

      // fetch and merge the actual review lists from both products
      var perProductReviews = await Promise.all(
        PRODUCT_IDS.map(function(id, i){ return fetchAllReviewsForProduct(id, aggs[i].reviewCount || 0); })
      );
      var allFetched = [].concat.apply([], perProductReviews);

      allReviews = allFetched.map(function(r){
        return {
          rating: r.rating || 5,
          title: r.title || '',
          body: r.body || '',
          name: (r.reviewer && r.reviewer.displayName) || 'Anonymous',
          avatar: (r.reviewer && r.reviewer.avatarUrl) || null,
          media: r.media || r.reviewMedia || r.mediaItems || [],
          date: r.dateCreated ? new Date(r.dateCreated).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''
        };
      });
      allReviews.sort(function(a, b){ return (b.media && b.media.length ? 1 : 0) - (a.media && a.media.length ? 1 : 0); });

      render(); initSort(); initSearch(); wireWriteBtn();
      if (!resizeBound){ resizeBound = true; window.addEventListener('resize', render); }
    } catch (err){
      console.error('[DLP] Okendo reviews error:', err);
      render();
    }
  }

  function init(){
    loadOkendoReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();






// (function(){
//   'use strict';
//   var root = document.querySelector('[data-dlp-reviews]');
//   if (!root) {
//     console.log('DLP Reviews section not found.');
//     return;
//   }
//   var STORE_ID = root.dataset.okendoStoreId;
//   var PRODUCT_IDS = {
//     Standard: root.dataset.okendoProductIdStandard,
//     Large: root.dataset.okendoProductIdLarge
//   };
//   var currentSize = root.dataset.defaultSize === 'standard' ? 'Standard' : 'Large';
//   var PRODUCT_ID = PRODUCT_IDS[currentSize];

//   var PER_PAGE = 3;
//   var allReviews = [];
//   var currentPage = 1;
//   var activeStarFilter = null;
//   var resizeBound = false; // guard so we don't stack window resize listeners on every size switch

//   function $(sel){ return root.querySelector(sel); }
//   function $all(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

//   function getInitials(name){
//     if (!name) return '?';
//     var parts = name.trim().split(/\s+/);
//     if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
//     return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
//   }

//   function getFiltered(){
//     var q = ($('[data-dlp-rev-search]') && $('[data-dlp-rev-search]').value || '').toLowerCase().trim();
//     return allReviews.filter(function(r){
//       var matchStar = activeStarFilter === null || r.rating === activeStarFilter;
//       var matchSearch = !q || r.body.toLowerCase().indexOf(q) !== -1 || r.name.toLowerCase().indexOf(q) !== -1 || r.title.toLowerCase().indexOf(q) !== -1;
//       return matchStar && matchSearch;
//     });
//   }

//   function starsHTML(rating){
//     var r = Math.min(5, Math.max(0, Math.round(rating)));
//     var out = '';
//     for (var i = 0; i < 5; i++){
//       out += i < r
//         ? '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>'
//         : '<svg width="20" height="20" viewBox="0 0 20 20" style="opacity:.25"><path d="M10 1.25L12.575 6.885L18.75 7.64L14.175 11.845L15.45 18L10 14.75L4.55 18L5.825 11.845L1.25 7.64L7.425 6.885L10 1.25Z" fill="#ffbc00"/></svg>';
//     }
//     return out;
//   }

//   function cardHTML(r){
//     var LIMIT = 180;
//     var isLong = r.body.length > LIMIT;
//     var shortText = isLong ? r.body.slice(0, LIMIT).trimEnd() + '…' : r.body;
//     var bodyId = 'dlp-rev-body-' + Math.random().toString(36).slice(2, 8);
//     var mediaHTML = '';
//     if (r.media && r.media.length){
//       var first = r.media[0];
//       if (first.type === 'video' && (first.fullWebmUrl || first.videoUrl || first.fullSizeUrl)){
//         var videoSrc = first.fullWebmUrl || first.videoUrl || first.fullSizeUrl;
//         mediaHTML = '<div class="dlp-rev-media"><video controls playsinline preload="metadata" poster="' + (first.videoPosterUrl || first.thumbnailUrl || '') + '"><source src="' + videoSrc + '"></video></div>';
//       } else {
//         var imgSrc = first.fullSizeUrl || first.thumbnailUrl || first.imageUrl || first.url;
//         if (imgSrc) mediaHTML = '<div class="dlp-rev-media"><img src="' + imgSrc + '" alt="" loading="lazy"></div>';
//       }
//     }
//     var avatarHTML = r.avatar
//       ? '<img src="' + r.avatar + '" alt="' + r.name + '" class="dlp-rev-avatar" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'"><div class="dlp-rev-avatar dlp-rev-avatar-initials" style="display:none">' + getInitials(r.name) + '</div>'
//       : '<div class="dlp-rev-avatar dlp-rev-avatar-initials">' + getInitials(r.name) + '</div>';
//     return '' +
//       '<div class="dlp-rev-card">' + mediaHTML +
//       '<div class="dlp-rev-card-top"><span class="dlp-rev-card-stars">' + starsHTML(r.rating) + '</span><span class="dlp-rev-verified">Verified</span></div>' +
//       (r.title ? '<div class="dlp-rev-card-title">' + r.title + '</div>' : '<div class="dlp-rev-card-title" style="min-height:44px"></div>') +
//       '<div class="dlp-rev-card-body" id="' + bodyId + '" data-full="' + r.body.replace(/"/g, '&quot;') + '" data-short="' + shortText.replace(/"/g, '&quot;') + '" data-expanded="false">' +
//       '<span class="dlp-rev-body-text">' + shortText + '</span>' + (isLong ? '<button type="button" class="dlp-rev-read-more" data-target="' + bodyId + '">Read More</button>' : '') + '</div>' +
//       '<div class="dlp-rev-card-auth">' + avatarHTML + '<div><span class="dlp-rev-card-name">' + r.name + '</span>' + (r.date ? '<span class="dlp-rev-card-date">' + r.date + '</span>' : '') + '</div></div>' +
//       '</div>';
//   }

//   function getPageNumbers(current, total){
//     var pages = [];
//     if (total <= 7){ for (var i = 1; i <= total; i++) pages.push(i); return pages; }
//     pages.push(1);
//     if (current > 3) pages.push('...');
//     var start = Math.max(2, current - 1), end = Math.min(total - 1, current + 1);
//     for (var j = start; j <= end; j++) pages.push(j);
//     if (current < total - 2) pages.push('...');
//     pages.push(total);
//     return pages;
//   }

//   function render(){
//     var grid = $('[data-dlp-rev-dynamic-grid]');
//     var pages = $('[data-dlp-rev-pages]');
//     if (!grid || !pages) return;
//     var filtered = getFiltered();

//     if (!filtered.length){
//       var msg = allReviews.length === 0 ? 'No reviews yet. Be the first to leave a review!' : 'No reviews match your search.';
//       grid.innerHTML = '<p class="dlp-rev-loading">' + msg + '</p>';
//       pages.innerHTML = '';
//       return;
//     }

//     var isMobile = window.innerWidth < 768;
//     if (isMobile){
//       var showCount = currentPage * PER_PAGE;
//       var slice = filtered.slice(0, showCount);
//       var hasMore = showCount < filtered.length;
//       grid.innerHTML = slice.map(cardHTML).join('');
//       pages.innerHTML = hasMore ? '<button type="button" class="dlp-rev-load-more" data-dlp-rev-load-more>Load more</button>' : '';
//     } else {
//       var totalPages = Math.ceil(filtered.length / PER_PAGE);
//       if (currentPage > totalPages) currentPage = 1;
//       var slice2 = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);
//       grid.innerHTML = slice2.map(cardHTML).join('');

//       var html = '';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="1" ' + (currentPage === 1 ? 'disabled' : '') + '><span>«</span></button>';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage - 1) + '" ' + (currentPage === 1 ? 'disabled' : '') + '><span>‹</span></button>';
//       getPageNumbers(currentPage, totalPages).forEach(function(p){
//         if (p === '...') html += '<span class="dlp-pg-ellipsis">…</span>';
//         else html += '<button type="button" class="dlp-pg' + (p === currentPage ? ' is-active' : '') + '" data-page="' + p + '">' + p + '</button>';
//       });
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + (currentPage + 1) + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>›</span></button>';
//       html += '<button type="button" class="dlp-pg dlp-nav-btn" data-page="' + totalPages + '" ' + (currentPage === totalPages ? 'disabled' : '') + '><span>»</span></button>';
//       pages.innerHTML = html;
//     }
//   }

//   root.addEventListener('click', function(e){
//     var pageBtn = e.target.closest('[data-page]');
//     if (pageBtn){ currentPage = parseInt(pageBtn.dataset.page, 10) || 1; render(); return; }
//     var loadMore = e.target.closest('[data-dlp-rev-load-more]');
//     if (loadMore){ currentPage++; render(); return; }
//     var readMore = e.target.closest('.dlp-rev-read-more');
//     if (readMore){
//       var bodyEl = document.getElementById(readMore.dataset.target);
//       if (!bodyEl) return;
//       var textEl = bodyEl.querySelector('.dlp-rev-body-text');
//       var isExpanded = bodyEl.dataset.expanded === 'true';
//       if (isExpanded){ textEl.textContent = bodyEl.dataset.short; readMore.textContent = 'Read More'; bodyEl.dataset.expanded = 'false'; }
//       else { textEl.textContent = bodyEl.dataset.full; readMore.textContent = 'Read Less'; bodyEl.dataset.expanded = 'true'; }
//     }
//   });

//   function buildStarBarsFromAggregate(agg){
//     var barsEl = $('[data-dlp-rev-bars]');
//     if (!barsEl) return;
//     var dist = agg.reviewCountByLevel || {};
//     var total = agg.reviewCount || 1;
//     var html = '';
//     [5, 4, 3, 2, 1].forEach(function(star){
//       var count = dist['level' + star + 'Count'] || 0;
//       var pct = Math.round((count / total) * 100);
//       var isActive = activeStarFilter === star;
//       var filled = '<span class="dlp-rev-bar-stars__filled">' + Array(star + 1).join('★') + '</span>';
//       var empty = star < 5 ? '<span class="dlp-rev-bar-stars__empty">' + Array(5 - star + 1).join('★') + '</span>' : '';
//       html += '<div class="dlp-rev-bar-row' + (isActive ? ' is-active' : '') + '" data-star="' + star + '">' +
//         '<span class="dlp-rev-bar-stars">' + filled + empty + '</span>' +
//         '<div class="dlp-rev-bar-track"><div class="dlp-rev-bar-fill" style="width:' + pct + '%"></div></div>' +
//         '<span class="dlp-rev-bar-count">' + count + '</span></div>';
//     });
//     barsEl.innerHTML = html;
//     $all('.dlp-rev-bar-row').forEach(function(row){
//       row.addEventListener('click', function(){
//         var star = parseInt(row.dataset.star, 10);
//         activeStarFilter = activeStarFilter === star ? null : star;
//         currentPage = 1; render(); buildStarBarsFromAggregate(agg);
//       });
//     });
//   }

//   function initSearch(){
//     var input = $('[data-dlp-rev-search]'); if (!input) return;
//     if (input._dlpBound) return; // avoid double-binding across size switches
//     input._dlpBound = true;
//     input.addEventListener('input', function(){ currentPage = 1; render(); });
//   }
//   function initSort(){
//     var select = $('[data-dlp-rev-sort]'); if (!select) return;
//     if (select._dlpBound) return; // avoid double-binding across size switches
//     select._dlpBound = true;
//     select.addEventListener('change', function(){
//       currentPage = 1;
//       if (this.value === 'highest_rating') allReviews.sort(function(a, b){ return b.rating - a.rating; });
//       else if (this.value === 'lowest_rating') allReviews.sort(function(a, b){ return a.rating - b.rating; });
//       render();
//     });
//   }
//   function wireWriteBtn(){
//     var btn = $('[data-dlp-rev-write]'); if (!btn) return;
//     if (btn._dlpBound) return; // avoid double-binding across size switches
//     btn._dlpBound = true;
//     btn.addEventListener('click', function(){
//       var okendoBtn = document.querySelector('.oke-w-writeReview');
//       if (okendoBtn) okendoBtn.click();
//       else document.querySelector('[data-oke-widget]') && document.querySelector('[data-oke-widget]').scrollIntoView({ behavior: 'smooth' });
//     });
//   }

//   function updateSitewideCount(total, avg){
//     var totalFormatted = Number(total).toLocaleString();
//     document.querySelectorAll('[data-dlp-review-count]').forEach(function(el){ el.textContent = totalFormatted; });
//     document.querySelectorAll('[data-dlp-rating-score]').forEach(function(el){ el.textContent = avg + '/5'; });
//   }

//   async function loadOkendoReviews(productId){
//     // reset per-product state so switching sizes doesn't blend review sets
//     allReviews = [];
//     currentPage = 1;
//     activeStarFilter = null;

//     var searchInput = $('[data-dlp-rev-search]');
//     if (searchInput) searchInput.value = '';
//     var sortSelect = $('[data-dlp-rev-sort]');
//     if (sortSelect) sortSelect.value = 'created_at';

//     var grid = $('[data-dlp-rev-dynamic-grid]');
//     if (grid) grid.innerHTML = '<p class="dlp-rev-loading">Loading reviews…</p>';

//     if (!STORE_ID || !productId) { render(); return; }
//     try {
//       var aggRes = await fetch('https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + productId + '/review_aggregate');
//       var aggData = await aggRes.json();
//       var agg = aggData.reviewAggregate || {};
//       var total = agg.reviewCount || 0;
//       var avg = total ? (agg.reviewRatingValuesTotal / total).toFixed(1) : '0.0';

//       var countEl = $('[data-dlp-rev-count]'); if (countEl) countEl.textContent = 'Based on ' + Number(total).toLocaleString() + ' reviews';
//       var avgEl = $('[data-dlp-rev-avg]'); if (avgEl) avgEl.textContent = avg;
//       buildStarBarsFromAggregate(agg);

//       var seenIds = {};
//       var allFetched = [];
//       var nextUrl = 'https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + productId + '/reviews?limit=100';
//       while (nextUrl){
//         var res = await fetch(nextUrl);
//         if (!res.ok) break;
//         var data = await res.json();
//         var batch = data.reviews || [];
//         if (!batch.length) break;
//         batch.forEach(function(r){
//           var uid = r.reviewId || r.id || ((r.dateCreated || '') + '|' + r.rating + '|' + (r.reviewer && r.reviewer.displayName) + '|' + (r.body || '').slice(0, 30));
//           if (!seenIds[uid]){ seenIds[uid] = true; allFetched.push(r); }
//         });
//         nextUrl = data.nextUrl ? ('https://api.okendo.io/v1' + (data.nextUrl.indexOf('/v1') === 0 ? data.nextUrl.slice(3) : data.nextUrl)) : null;
//         if (allFetched.length >= total && total > 0) break;
//       }

//       allReviews = allFetched.map(function(r){
//         return {
//           rating: r.rating || 5,
//           title: r.title || '',
//           body: r.body || '',
//           name: (r.reviewer && r.reviewer.displayName) || 'Anonymous',
//           avatar: (r.reviewer && r.reviewer.avatarUrl) || null,
//           media: r.media || r.reviewMedia || r.mediaItems || [],
//           date: r.dateCreated ? new Date(r.dateCreated).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''
//         };
//       });
//       allReviews.sort(function(a, b){ return (b.media && b.media.length ? 1 : 0) - (a.media && a.media.length ? 1 : 0); });

//       render(); initSort(); initSearch(); wireWriteBtn();
//       if (!resizeBound){ resizeBound = true; window.addEventListener('resize', render); }
//     } catch (err){
//       console.error('[DLP] Okendo reviews error:', err);
//       render();
//     }
//   }

//   async function loadSitewideAggregate(){
//   var ids = [PRODUCT_IDS.Standard, PRODUCT_IDS.Large].filter(Boolean);
//   if (!STORE_ID || !ids.length) return;

//   var combinedTotal = 0;
//   var combinedRatingSum = 0;

//   await Promise.all(ids.map(async function(id){
//     try {
//       var res = await fetch('https://api.okendo.io/v1/stores/' + STORE_ID + '/products/' + id + '/review_aggregate');
//       var data = await res.json();
//       var agg = data.reviewAggregate || {};
//       combinedTotal += agg.reviewCount || 0;
//       combinedRatingSum += agg.reviewRatingValuesTotal || 0;
//     } catch (err) {
//       console.error('[DLP] Sitewide aggregate fetch failed for product ' + id, err);
//     }
//   }));

//   var combinedAvg = combinedTotal ? (combinedRatingSum / combinedTotal).toFixed(1) : '0.0';
//   updateSitewideCount(combinedTotal, combinedAvg);
// }

//   // ── react to the hero's size toggle ─────────────────────────────
//   document.addEventListener('dlp:size-changed', function(e){
//     var size = e.detail && e.detail.size;
//     if (!size || !PRODUCT_IDS[size] || size === currentSize) return;
//     currentSize = size;
//     PRODUCT_ID = PRODUCT_IDS[currentSize];
//     loadOkendoReviews(PRODUCT_ID);
//   });

//   async function init(){
//   await Promise.all([
//     loadOkendoReviews(PRODUCT_ID),
//     loadSitewideAggregate()
//   ]);
// }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();